var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocplaceFrame1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.85 10.39L19.91 9.33C20.69 8.55 20.69 7.28 19.91 6.5L18.5 5.09C17.72 4.31 16.45 4.31 15.67 5.09L14.61 6.15L18.85 10.39ZM13.19 7.56L4 16.76V21H8.24L17.43 11.81L13.19 7.56ZM19 17.5C19 19.69 16.46 21 14 21C13.45 21 13 20.55 13 20C13 19.45 13.45 19 14 19C15.54 19 17 18.27 17 17.5C17 17.03 16.52 16.63 15.77 16.3L17.25 14.82C18.32 15.45 19 16.29 19 17.5ZM4.58 13.35C3.61 12.79 3 12.06 3 11C3 9.2 4.89 8.37 6.56 7.64C7.59 7.18 9 6.56 9 6C9 5.59 8.22 5 7 5C5.74 5 5.2 5.61 5.17 5.64C4.82 6.05 4.19 6.1 3.77 5.76C3.56902 5.5956 3.44068 5.35882 3.41262 5.10069C3.38456 4.84256 3.45904 4.58374 3.62 4.38C3.73 4.24 4.76 3 7 3C9.24 3 11 4.32 11 6C11 7.87 9.07 8.72 7.36 9.47C6.42 9.88 5 10.5 5 11C5 11.31 5.43 11.6 6.07 11.86L4.58 13.35Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocplaceFrame1);
export default __webpack_public_path__ + "static/media/Docplace Frame (1).c4bbae3865e8f7eda6dd437c0bbd69f6.svg";
export { ForwardRef as ReactComponent };